/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:2ae65c31-ac32-43ce-a573-802c9d6ddc41",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_rnAJk8aKy",
    "aws_user_pools_web_client_id": "eotrcap4mtadbo5htbsq3papr",
    "oauth": {},
    "aws_user_files_s3_bucket": "ciphersamples191733-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
